import React from 'react';
import ComingSoon from '@/components/shared/ComingSoonSection';
import './StatementPage.scss';

const StatementPage = () => {
  return (
    <div className="StatementtPage">
      <ComingSoon title="StatementtPage" />
    </div>
  );
};

export default StatementPage;